import { gql } from '@apollo/client';

export const fetchProductInstancesForEntitlementQueryPPC = gql`
  query fetchProductInstancesForEntitlementQueryPPC(
    $id: String!
    $transactionAccountId: String!
    $searchLinkedEntitlementParams: SearchLinkedEntitlementParams!
  ) {
    entitlementDetails(id: $id, filters: { transactionAccountId: $transactionAccountId }) {
      id
      linkedEntitlements(searchLinkedEntitlementParams: $searchLinkedEntitlementParams) {
        entitlementId
        createdDate
        billingFrequency
        edition
        logoId
        productId
        productName
        billingStatus
        provisioningStatus
        scheduledChanges {
          subscriptionScheduleAction
        }
        provisionedResourceDetails {
          organisationName
          organisationId
        }
        cloudSiteId
        cloudSiteHostname
        activeUsers
        userTier
        optedQuantitySource
        entitlementNumber
        linkedAppsId
        trial
        isApp
        isSandbox
        isAddOn
        isFutureDatedSubscription
        offering {
          pricingType
          id
          name
        }
        latestPeriodEndDate
      }
    }
  }
`;
